export function resolveSelectedUseId(selectedUseId: string | null, availableUses: ReadonlyArray<{ id: string }>) {
    if (selectedUseId && availableUses.some(use => use.id === selectedUseId)) {
        return selectedUseId;
    }
    return availableUses.length === 1 ? availableUses[0]!.id : null;
}
